<template>
  <div class="contractWithdrawalFormPdf">
    <div class="contractWithdrawalFormPdf__inner">
      <div class="contractWithdrawalFormPdf__top">
        <h2 class="contractWithdrawalFormPdf__topTitle">{{ data.Title }}</h2>
        <a :href="data.Link" target="_blank" class="contractWithdrawalFormPdf__topLink">
          <img
            class="contractWithdrawalFormPdf__topLinkIcon"
            src="/images/pdf.svg"
            alt="pdf icon"
          />
          Pobierz PDF
        </a>
      </div>
      <div class="contractWithdrawalFormPdf__content" v-html="data.Content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContractWithdrawalFormPdf',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.contractWithdrawalFormPdf {
  margin: 1.5rem 0;
  padding: 2rem;
  background-color: $cBg;

  @include rwd('large-phone') {
    padding: 0;
    background-color: transparent;
  }

  &__inner {
    padding: 3rem;
    background-color: $cWhite;
    border-radius: 4px;
    border: 1px solid $cAddLight;

    @include rwd('tablet') {
      padding: 1.5rem;
    }
  }

  &__top {
    display: flex;
    margin-bottom: 2rem;
    align-items: center;
    justify-content: space-between;

    @include rwd('large-phone') {
      flex-direction: column-reverse;
    }
  }

  &__topTitle,
  &__topLink {
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 1.8rem;
    color: $cMainDark;
  }

  &__topTitle {
    padding-right: 1.5rem;
    font-style: italic;
    text-transform: uppercase;

    @include rwd('large-phone') {
      padding-top: 1.5rem;
      padding-right: 0;
      text-align: center;
    }
  }

  &__topLink {
    display: flex;
    align-items: center;
    white-space: nowrap;
    transition: color $tr;

    &:hover {
      color: $cSecHover;
    }
  }

  &__topLinkIcon {
    padding-right: 1rem;
  }

  &__content {
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 2rem;
    color: $cMainLight;
    overflow: hidden;

    ::v-deep {
      .dot {
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          bottom: 6px;
          left: 0;
          width: 100%;
          height: 0;
          border-bottom: 2px dotted $cMainLight;
          opacity: 0.5;
        }

        span {
          position: relative;
          background-color: $cWhite;
          z-index: 1;
        }

        &--half {
          &::before {
            width: 50%;

            @include rwd('tablet') {
              width: 100%;
            }
          }
        }
      }

      table {
        border: 1px solid $cMainLight;

        td,
        th {
          padding: 5px;
          border-right: 1px solid $cMainLight;
        }

        tr {
          border-bottom: 1px solid $cMainLight;
        }
      }
    }
  }
}
</style>
